// Thin wrapper over the gtag.js snippet in index.html. `gtag` is defined
// inline there so it exists on every real page load; the guard covers
// non-browser contexts (tests, SSR-style tooling).
export function trackGAEvent(name, params = {}) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    // Strip absent values so optional fields (e.g. language on an
    // English-only create) don't reach GA as the string "undefined".
    const cleaned = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== null)
    );
    window.gtag('event', name, cleaned);
    // Dev-only echo, mirroring the Mixpanel wrapper. Excluded from prod builds.
    if (import.meta.env.DEV) {
      console.log('[GA Event]\n\n', `${name}`, Object.keys(cleaned).length ? { ...cleaned } : '');
    }
  }
}
